import { THIEN_CAN_ORDER, DIA_CHI_ORDER } from './canchi_year.js';
import { getSolarTermDate } from './solar_terms.js';
import {
  DEFAULT_TZ_OFFSET_MINUTES,
  normalizeTimezoneOffset,
  toUtcFromLocalTime
} from './time.js';

const MONTH_BRANCH_ORDER = [
  'Dan', 'Mao', 'Thin', 'Ty_', 'Ngo', 'Mui',
  'Than', 'Dau', 'Tuat', 'Hoi', 'Ty', 'Suu'
];

const MONTH_STEM_BASE_BY_YEAR_STEM = {
  Giap: 'Binh',
  Ky: 'Binh',
  At: 'Mau',
  Canh: 'Mau',
  Binh: 'Canh',
  Tan: 'Canh',
  Dinh: 'Nham',
  Nham: 'Nham',
  Mau: 'Giap',
  Quy: 'Giap'
};

const SOLAR_TERM_TO_BRANCH = [
  { name: 'Lap Xuan', branch: 'Dan', monthIndex: 0 },
  { name: 'Kinh Trập', branch: 'Mao', monthIndex: 1 },
  { name: 'Thanh Minh', branch: 'Thin', monthIndex: 2 },
  { name: 'Lap Ha', branch: 'Ty_', monthIndex: 3 },
  { name: 'Mang Chung', branch: 'Ngo', monthIndex: 4 },
  { name: 'Tieu Thu', branch: 'Mui', monthIndex: 5 },
  { name: 'Lap Thu', branch: 'Than', monthIndex: 6 },
  { name: 'Bach Lo', branch: 'Dau', monthIndex: 7 },
  { name: 'Han Lo', branch: 'Tuat', monthIndex: 8 },
  { name: 'Lap Dong', branch: 'Hoi', monthIndex: 9 },
  { name: 'Dai Tuyet', branch: 'Ty', monthIndex: 10 },
  { name: 'Tieu Han', branch: 'Suu', monthIndex: 11 }
];

const buildBoundaryForYear = (year) => (
  SOLAR_TERM_TO_BRANCH.map((item) => {
    const start = getSolarTermDate(year, item.name);
    return start ? { ...item, start } : null;
  }).filter(Boolean)
);

const getMonthBranchBySolarTerm = (dateParts, hour = 0, timezoneOffsetMinutes = DEFAULT_TZ_OFFSET_MINUTES) => {
  const normalizedOffset = normalizeTimezoneOffset(timezoneOffsetMinutes);
  const year = dateParts.year;
  const targetTime = toUtcFromLocalTime(dateParts, hour, normalizedOffset);
  const candidates = [
    ...buildBoundaryForYear(year - 1),
    ...buildBoundaryForYear(year),
    ...buildBoundaryForYear(year + 1)
  ].filter((item) => item?.start);

  if (candidates.length === 0) {
    throw new Error(`[Bazi] Khong tim thay tiet khi cho nam ${year}`);
  }

  const match = candidates
    .filter((item) => item.start.getTime() <= targetTime)
    .sort((a, b) => b.start - a.start)[0];

  const resolved = match || candidates[0];
  const termIndex = SOLAR_TERM_TO_BRANCH.findIndex((item) => item.name === resolved.name);
  const nextIndex = (termIndex + 1) % SOLAR_TERM_TO_BRANCH.length;
  const nextTerm = SOLAR_TERM_TO_BRANCH[nextIndex];
  const termYear = resolved.start.getUTCFullYear();
  const nextTermYear = nextIndex === 0 ? termYear + 1 : termYear;
  const nextTermStart = getSolarTermDate(nextTermYear, nextTerm.name);

  return {
    ...resolved,
    termIndex,
    nextTerm: nextTerm.name,
    nextTermStart
  };
};

export function getCanChiMonth(yearCanIndex, dateParts, hour = 0, timezoneOffsetMinutes = DEFAULT_TZ_OFFSET_MINUTES) {
  const {
    branch,
    name: solarTerm,
    monthIndex,
    start: solarTermStart,
    termIndex,
    nextTerm,
    nextTermStart
  } = getMonthBranchBySolarTerm(
    dateParts,
    hour,
    timezoneOffsetMinutes
  );
  const branchIndex = DIA_CHI_ORDER.indexOf(branch);
  const yearStem = THIEN_CAN_ORDER[yearCanIndex];
  const startStem = MONTH_STEM_BASE_BY_YEAR_STEM[yearStem];
  const startIndex = THIEN_CAN_ORDER.indexOf(startStem);
  const canIndex = (startIndex + monthIndex + 10) % 10;

  return {
    branch,
    canIndex,
    chiIndex: branchIndex,
    can: THIEN_CAN_ORDER[canIndex],
    chi: DIA_CHI_ORDER[branchIndex],
    label: `${THIEN_CAN_ORDER[canIndex]} ${DIA_CHI_ORDER[branchIndex]}`,
    monthIndex: monthIndex ?? MONTH_BRANCH_ORDER.indexOf(branch),
    monthBranchIndex: branchIndex,
    monthOrderFromLichun: (monthIndex ?? termIndex ?? 0) + 1,
    solarTerm,
    solarTermStart,
    nextSolarTerm: nextTerm,
    nextSolarTermStart: nextTermStart
  };
}
